import { render, staticRenderFns } from "./laspppa-icon.vue?vue&type=template&id=7bc81065"
import script from "./laspppa-icon.vue?vue&type=script&lang=js"
export * from "./laspppa-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports